//
//
//
//
//
//
//
//

import {imageMixin} from "./image.mixin";
import {EMPTY_GIF, lazyMixin} from "./lazy.mixin";
import {parseSize} from "~image";
const defineComponent = (opts) => opts;
export default defineComponent({
  name: "NuxtImg",
  mixins: [imageMixin, lazyMixin],
  computed: {
    nAttrs() {
      const attrs = this.nImgAttrs;
      if (this.sizes) {
        const {sizes, srcset} = this.nSizes;
        attrs.sizes = sizes;
        attrs.srcset = srcset;
      }
      return attrs;
    },
    nSrc() {
      const src = this.sizes ? this.nSizes.src : this.$img(this.src, this.nModifiers, this.nOptions);
      if (this.lazyLoad) {
        return EMPTY_GIF;
      }
      return src;
    },
    nSizes() {
      return this.$img.getSizes(this.src, {
        ...this.nOptions,
        sizes: this.sizes,
        modifiers: {
          ...this.nModifiers,
          width: parseSize(this.width),
          height: parseSize(this.height)
        }
      });
    }
  },
  created() {
    if (process.server && process.static) {
      if (this.sizes) {
        this.nSizes;
      }
    }
  }
});
